export const handle = {
	breadcrumb: 'Change log',
}

export default function ChangeLogRoute() {
	return <p>Change log</p>
}
